<div id="researchChart" *ngIf="dataSet">
  <div class="chart-settings">
    <div class="display-section">
      <span
        class="ticker"
        [title]="defaultData.companyFullName"
        [innerHtml]="defaultData.companyFullName | textEllipsis: 30"
      ></span>
      <div *ngIf="displayDataSet">
        <span
          class="line-item"
          [title]="displayData.lineItemName"
          [innerHtml]="displayData.lineItemName | textEllipsis: 20"
        ></span>
        <span class="period">{{ displayData.period }}</span>
        <span class="magnitude" *ngIf="displayData.magnitude"
          >&nbsp;(in {{ displayData.magnitude }})</span
        >
        <div
          class="standard-deviation"
          *ngIf="selectedValue === 'distribution-analysis'"
        >
          <span *ngIf="displayData.consensusValue !== ''"
            >Consensus:&nbsp;{{ displayData.consensusValue }}</span
          >
          <span *ngIf="displayData.stdDev !== ''" class="std"
            >Standard Deviation:&nbsp; {{ displayData.stdDev }}</span
          >
        </div>
      </div>
    </div>
    <div class="options-section">
      <span class="chart-type-select">
        <nz-select
          [(ngModel)]="selectedValue"
          nzPlaceHolder="Choose"
          (ngModelChange)="onChartTypeChange()"
          [nzDropdownClassName]="'chart-type-dropdown'"
          nzOptionOverflowSize = "12"
          nzOptionHeightPx="24"
          id="selectChart"
        >
          <nz-option-group
            nzLabel="Distribution"
            *ngIf="
              defaultData.source &&
              defaultData.source.toLowerCase() === 'consensus'
            "
          >
            <nz-option
              nzValue="distribution-analysis"
              *ngIf="defaultData.cut !== 'SCH'"
              nzLabel="Analysis"
            >
            </nz-option>
            <nz-option nzValue="distribution-range" nzLabel="Range"></nz-option>
          </nz-option-group>
          <nz-option-group nzLabel="Trend">
            <nz-option nzValue="trend-bar" nzLabel="Bar Chart"></nz-option>
          </nz-option-group>
          <nz-option-group
            nzLabel="Revision by sources"
            *ngIf="
              defaultData.source &&
              defaultData.source.toLowerCase() !== 'filings'
            "
          >
            <nz-option
              nzValue="revision-daily"
              nzLabel="Daily - 1 year"
            ></nz-option>
            <nz-option
              nzValue="revision-monthly"
              nzLabel="Monthly - 2 year"
            ></nz-option>
            <nz-option
              nzValue="revision-analysis"
              nzLabel="Revision Analysis"
              *ngIf="defaultData.forecast"
            ></nz-option>
          </nz-option-group>
          <nz-option-group
            nzLabel="Revision vs. peers"
            *ngIf="defaultData.isPeers && defaultData.cut === 'NMV'"
          >
            <nz-option
              nzValue="revision-peer-daily"
              nzLabel="Daily - 1 year"
            ></nz-option>
            <nz-option
              nzValue="revision-peer-monthly"
              nzLabel="Monthly - 2 year"
            ></nz-option>
          </nz-option-group>
        </nz-select>
      </span>
      <div id="expand-btn" (click)="expandChart()">
        <va-icon size="small" name="expand-double-arrows" class="expand-btn-icon"></va-icon>
      </div>
    </div>
  </div>
  <div class="research-carousel-holder" (click)="setFocus($event)">
    <va-icon
      size="small"
      name="less-than"
      class="leftArrow"
      (click)="prevChart()"
    ></va-icon>

    <nz-carousel
      [nzEffect]="effect"
      [nzEnableSwipe]="false"
      *ngIf="dataSet"
      (nzAfterChange)="carouselChange($event)"
    >
      <div nz-carousel-content *ngFor="let index of chartList">
        <div class="chart-holder" *ngIf="index === selectedValue">
          <app-chart-plotter
            [(dataToUse)]="dataToUse"
            [chartType]="selectedValue"
            (chartDataSet)="setDisplayData($event)"
            *ngIf="dataSet"
          ></app-chart-plotter>
        </div>
      </div>
    </nz-carousel>
    <va-icon
      size="small"
      name="greater-than"
      class="rightArrow"
      (click)="nextChart()"
    ></va-icon>
  </div>
</div>
<app-chart-popup
  [chartType]="chartPopupType"
  [dataToUse]="chartPopupDataToUse"
  [(showPopup)]="chartPopupVisible"
  (closePopup)="hideChartPopup()"
  [beginningStateReferrer]="beginningStateReferrer"
  [closeFeature]="feature"
></app-chart-popup>
